import React from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from '../portal-admin/portal-accounts-table.jsx';

if (document.getElementById('react-component-g4-logistics-portal-view-customer-with-all-users')) {
  let customerId = document.getElementById(
    'react-component-g4-logistics-portal-view-customer-with-all-users'
  ).getAttribute('data-customer-id');

  ReactDOM.render(<PortalAccountsTable
    url={"/api/v1/portal/customers/view/" + customerId + "/all-User"}
    message_if_none='No Users yet.'
  />,
    document.getElementById('react-component-g4-logistics-portal-view-customer-with-all-users')
  );
}